import { CakeApiBase } from '../CakeApiBase';

export class NotificationApi extends CakeApiBase {
  async pull(since): Promise<any[]> {
    return this.requestManager.get(`notifications?since=${since}`) as Promise<any[]>;
  }
}
